/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PriceBound } from './priceBound';


export interface AnqServiceModel { 
    id: string;
    serviceId?: string;
    serviceName?: string;
    systemName?: string;
    status: boolean;
    owner?: string;
    ownerId?: string;
    description?: string;
    createdDate: Date;
    updatedDateTime: Date;
    countryCodeIso?: string;
    countryCode?: string;
    priceBounds?: Array<PriceBound>;
}
